import { withStyles } from '@material-ui/core/styles';
import Show, { styles as showStyles } from './Show';

export { default as PlanListSlick } from './ListSlick';
export { default as FavoritePlanIndex } from './Favorite/FavoriteIndex';

export const PlanShow = withStyles(showStyles)(Show);
